<script>
import Vue from 'vue'
import axios from 'axios'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import { required, minLength, maxLength, email } from 'vuelidate/lib/validators'

/**
 Editar Contribuyente Component
 */
export default {
  components: { Layout, PageHeader },
  page: {
    title: 'Conceptos',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {
      title: 'Conceptos',
      form: {
        contribuyenteId: '',
        rfc: '',
        razonSocial: '',
        calle: '',
        colonia: '',
        estado: '',
        municipio: '',
        localidad: '',
        cp: '',
        correo: '',
        telefono: '',
      },
      items: [
        {
          text: 'Sistema Tributario',
          href: '/',
        },
        {
          text: 'Contribuyente',
          href: '/contribuyentes/',
        },
        {
          text: 'Editar',
          active: true,
        },
      ],
      submitted: false,
      isBusy: false,
    }
  },
  validations: {
    form: {
      razonSocial: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(255),
      },
      calle: { required, minLength: minLength(2), maxLength: maxLength(255) },
      colonia: { required, minLength: minLength(2), maxLength: maxLength(255) },
      estado: { required, minLength: minLength(2), maxLength: maxLength(255) },
      municipio: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(255),
      },
      localidad: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(255),
      },
      cp: { required, minLength: minLength(2), maxLength: maxLength(10) },
      correo: {
        required,
        email,
        minLength: minLength(2),
        maxLength: maxLength(255),
      },
      telefono: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(255),
      },
      rfc: {
        required,        
      },
    },
  },
  computed: {},
  mounted() {  
    this.loadContribuyente(this.$route.params.id)
  },
  methods: {
    loadContribuyente(id){
       axios
            .get(appConfig.recursosApi.contribuyentes + "/" + id )
            .then((response) => {
                this.form = response.data                
            })
             .catch(()=>  {
               // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
                this.$router.push('/500') ;
            });

    },    
    _validations() {
      return new Promise((resolve) => {
        if (this.$v.$error || !this.$v.$pending) {
          return resolve()
        }
        let poll = setInterval(() => {
          if (!this.$v.$pending) {
            clearInterval(poll)
            resolve()
          }
        }, 200)
      })
    },

    async isValid() {
      this.$v.$reset()
      this.$v.$touch()
      await this._validations()
      return Promise.resolve(!this.$v.$error)
    },

    async handleSubmit(e) {
      this.submitted = true
      const valid = await this.isValid()
      this.isBusy = false

      if (valid) {
        this.isBusy = true        
        axios
          .put(appConfig.recursosApi.contribuyentes, this.form)
          .then((response) => {
            this.isBusy = false
            this.$router.push('/contribuyentes/index/true')
          })
          .catch(() => {
            this.isBusy = false
            Vue.swal({
              type: 'error',
              title: 'Oops...',
              text: 'Ocurrio un error al intentar guardar los datos.',
              confirmButtonClass: 'btn btn-confirm mt-2',
            })
          })
      }
    },
  },
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-6">
        <div class="card-box">
          <h4 class="header-title m-t-0">Editar Contribuyente</h4>
          <p class="text-muted font-14 m-b-20"
            >Ingresa la información del Contribuyente.</p
          >

          <form @submit.prevent="handleSubmit">
            <div class="form-row">
              <div class="form-group col-md-5">
                <label for="name">
                  RFC
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="rfc"
                  v-model="form.rfc"
                  name="rfc"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.rfc.$error }"
                  type="text"
                  placeholder=""
                />                
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="name">
                  Razon Social
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="razonSocial"
                  v-model="form.razonSocial"
                  name="razonSocial"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.razonSocial.$error }"
                  type="text"
                  placeholder=""
                />
                <div
                  v-if="submitted && !$v.form.razonSocial.required"
                  class="invalid-feedback"
                  >La Razon Social es un campo requerido.</div
                >
                <span v-if="!$v.form.razonSocial.minLength"
                  >La razon social debe ser minimo de 2 caracteres.</span
                >
                <span v-if="!$v.form.razonSocial.maxLength"
                  >La Razon Social debe ser maximo de 255 caracteres.</span
                >
              </div>
            </div>
            <!-- Datos Usuario -->
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="calle">
                  Calle
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="calle"
                  v-model="form.calle"
                  name="calle"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.calle.$error }"
                  type="text"
                  placeholder=""
                />
                <div
                  v-if="submitted && $v.form.calle.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.calle.required"
                    >La calle es un campo requerido.</span
                  >
                  <span v-if="!$v.form.calle.minLength"
                    >La Calle debe ser minimo de 6 caracteres.</span
                  >                  
                </div>
              </div>
              <div class="form-group col-md-6">
                <label>
                  Colonia
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.colonia"
                  type="text"
                  name="colonia"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.colonia.$error }"
                  placeholder=""
                />
                <div
                  v-if="submitted && $v.form.colonia.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.colonia.required"
                    >La colonia es un campo requerido.</span
                  >                  
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="estado">
                  Estado
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="estado"
                  v-model="form.estado"
                  name="estado"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.estado.$error }"
                  type="text"
                  placeholder=""
                />
                <div
                  v-if="submitted && $v.form.estado.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.estado.required"
                    >El estado es un campo requerido.</span
                  >
                  <span v-if="!$v.form.estado.minLength"
                    >El estado debe ser minimo de 6 caracteres.</span
                  >                  
                </div>
              </div>
              <div class="form-group col-md-6">
                <label>
                  Municipio
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.municipio"
                  type="text"
                  name="municipio"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.municipio.$error }"
                  placeholder=""
                />
                <div
                  v-if="submitted && $v.form.municipio.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.municipio.required"
                    >El municipio es un campo requerido.</span
                  >                  
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="localidad">
                  Localidad
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="localidad"
                  v-model="form.localidad"
                  name="localidad"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.localidad.$error }"
                  type="text"
                  placeholder=""
                />
                <div
                  v-if="submitted && $v.form.localidad.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.localidad.required"
                    >La localidad es un campo requerido.</span
                  >
                  
                </div>
              </div>
              <div class="form-group col-md-6">
                <label>
                  Codigo Postal
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.cp"
                  type="text"
                  name="cp"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.cp.$error }"
                  placeholder=""
                />
                <div
                  v-if="submitted && $v.form.cp.$error"
                  class="invalid-feedback">
                  <span v-if="!$v.form.cp.required"
                    >El campo codigo postal es requerido.</span>                  
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="correo">
                  Correo
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="correo"
                  v-model="form.correo"
                  name="correo"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.correo.$error }"
                  type="text"
                  placeholder="" />
                <div
                  v-if="submitted && $v.form.correo.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.correo.required" >El correo es un campo requerido.</span
                  >
                  
                </div>
              </div>
              <div class="form-group col-md-6">
                <label>
                  Teléfono
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.telefono"
                  type="text"
                  name="telefono"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.telefono.$error }"
                  placeholder=""
                />
                <div
                  v-if="submitted && $v.form.telefono.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.telefono.required"
                    >El telefono es un campo requerido.</span
                  >                  
                </div>
              </div>
            </div>

            <div class="form-group text-right m-b-0">
              <button class="btn btn-primary" type="submit" :disabled="isBusy">
                <b-spinner v-show="isBusy" small></b-spinner> Guardar</button
              >
              <router-link
                class="btn btn-secondary m-l-5 ml-1"
                to="/contribuyentes/index"
              >
                Cancelar</router-link
              >
            </div>
          </form>
        </div>
        <!-- end card-box -->
      </div>
    </div>
  </Layout>
</template>